
        Component.define('hero', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el            = $(el);
const $wrapperSlider = $el.find('.wrapper-slider');
const $slider        = $wrapperSlider.find('.slider');
const $text          = $wrapperSlider.find(`.slider-text`);

if (wW > 1023) {
    $slider[0].addEventListener("mousemove", (e) => {
        const rotationLimit = 10;

        const x = e.clientX;
        const y = e.clientY;

        const middleX = window.innerWidth / 2;
        const middleY = window.innerHeight / 2;

        const offsetX = ((x - middleX) / middleX) * rotationLimit;
        const offsetY = ((y - middleY) / middleY) * rotationLimit;

        $slider.css("--rotateX", offsetX + "deg");
        $slider.css("--rotateY", -1 * offsetY + "deg");
    });
}

$slider.on('beforeChange init', function( event, slick, currentSlide, nextSlide ) {
    const $allIcons = $slider.find('.icon-image');
    TweenMax.set($allIcons, { opacity: 0, scale: .5 });

    const index = nextSlide || 0;

    const $currentSlide = $slider.find(`[data-slick-index="${index}"]`);
    const $icons        = $currentSlide.find('.icon-image');

    setTimeout(() => {
        TweenMax.to($icons, .5,
            { opacity: 1, ease: Quint.easeOut }
        );

        TweenMax.to($icons, 1.2,
            { scale: 1, ease: Elastic.easeOut }
        );
    }, 350);
});

let historyLabels = [];
function splitTextPreserveTags(element, index) {
    if (!historyLabels[index]) {
        historyLabels[index] = element.innerHTML;
    } else {
        element.innerHTML = historyLabels[index];
    }

    const text = element.innerHTML;
    const words = text.split(/(<\/?span[^>]*>|\s+)/).filter(Boolean);

    let result = words.map(word => {
        if (word.match(/<span[^>]*>/)) {
            return word.replace(/(<span[^>]*)(class="[^"]*)?([^>]*>)/, (match, p1, p2, p3) => {
                if (p2) {
                    if (!p2.includes('word')) {
                        return `${p1}${p2} word${p3}`;
                    }
                    return `${p1}${p2}${p3}`;
                } else {
                    return `${p1} class="word"${p3}`;
                }
            });
        } else if (word.match(/<\/span>/)) {
            return word;
        } else if (word.trim() === "") {
            return word;
        } else {
            return `<span class="word">${word}</span>`;
        }
    }).join('');

    // Remover spans aninhados desnecessários
    result = result.replace(/<span class="([^"]*)"><span class="word">([^<]*)<\/span><\/span>/g, '<span class="$1 word">$2</span>');
    // Corrigir spans com classes duplicadas
    result = result.replace(/class="([^"]*)" class="word"/g, 'class="$1 word"');
    // Remover spans aninhados com a mesma classe
    result = result.replace(/<span class="([^"]*) word"><span class="word">([^<]*)<\/span><\/span>/g, '<span class="$1 word">$2</span>');

    element.innerHTML = result;
}

splitTextPreserveTags($text[0], 0);

setTimeout(() => {
    TweenMax.staggerFrom($text.find('.word'), .4, {
        opacity: 0,
        y: 20,
    }, .03);
}, 300);

$slider.slick({
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed: 3000,
    autoplay: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    arrows: false,
    dots: true,
});

        });